import { ROLES } from '../constants'

// Roles de staff con los que el control room ya funciona: si el login resolvió alguno de estos,
// no tocamos nada. OJO con el enum: ROLES.COACH === 'professor', ROLES.PROFESSOR === 'tutor',
// ROLES.DIRECTOR / ROLES.ADMIN === 'director', ROLES.SUPERADMIN === 'admin'.
export const STAFF_ROLES: ROLES[] = [ROLES.SUPERADMIN, ROLES.DIRECTOR, ROLES.COACH, ROLES.PROFESSOR]

// Orden de preferencia para auto-promover cuando el login directo cayó en un rol no-staff
// (coach primero, después profesor/tutor). Director/admin no se promueven a propósito.
export const PROMOTABLE_STAFF_ROLES: ROLES[] = [ROLES.COACH, ROLES.PROFESSOR]

/**
 * Decide a qué rol de staff promover tras un login directo. El login con email+password no lleva el
 * claim `_profileId`, así que el backend (`verifyToken`) cae al primer profile activo, que para un
 * usuario multi-perfil suele ser uno de alumno. Si el rol resuelto no es de staff pero el usuario sí
 * tiene un rol de staff docente, devolvemos ese rol para reemitir el token; si no, `null` (no-op).
 */
export const resolveRolePromotion = (
    currentRole: ROLES | undefined,
    userRoles: ROLES[] | undefined
): ROLES | null => {
    if (!currentRole) return null
    if (STAFF_ROLES.includes(currentRole)) return null
    return PROMOTABLE_STAFF_ROLES.find((staffRole) => userRoles?.includes(staffRole)) ?? null
}
